module.exports = __webpack_public_path__ + "media/theme/blog__ico-comment-2-fd752957.png";